<mat-tab-group mat-align-tabs="start" (selectedTabChange)="selectTab($event)" style="margin-top: 10px">
  <mat-tab label="Members">
    <app-members [buttonEmitter]="tabEmitter" (showProgressEvent)="showProgressEvent" [tabIndex]="0"></app-members>
  </mat-tab>
  <mat-tab label="Teams">
    <app-teams [buttonEmitter]="tabEmitter" (showProgressEvent)="showProgressEvent" [tabIndex]="1"></app-teams>
  </mat-tab>
</mat-tab-group>
